import Vue from "vue";
import apiService from "./apiService";

class YoutubeService {
    getVideoDetail(videoId) {
        return new Promise((resolve, reject) => {
            const url = `https://www.googleapis.com/youtube/v3/videos?id=${videoId}&key=${Vue.prototype.$config.youtube_api_key}&part=snippet`;
            apiService.getWithoutApiUrl(url, new URLSearchParams())
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    // =====================================================================
    
}

export default new YoutubeService();
